import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzS2612 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_S2612: Record<
  Exclude<PageIdWoofzS2612, PageIdWoofzS2612.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzS2612.DOG_BREED_S2_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.TITLE_MENU,
    id: PageId.DOG_BREED_S2_6_12,
  },
  [PageIdWoofzS2612.DOG_AGE_S2_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    id: PageId.DOG_AGE_S2_6_12,
  },
  [PageIdWoofzS2612.SHELTER_S2_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    id: PageId.SHELTER_S2_6_12,
  },
  [PageIdWoofzS2612.COMMANDS_S2_6_12]: {
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
    id: PageId.COMMANDS_S2_6_12,
  },
  [PageIdWoofzS2612.SUBSCRIPTIONS_S2_6_12]: {
    hasHeader: false,
    id: PageId.SUBSCRIPTIONS_S2_6_12,
  },
  [PageIdWoofzS2612.CHAT_UPSELL_S2_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.CHAT_UPSELL_S2_6_12,
  },
  [PageIdWoofzS2612.UPSELL_1_S2_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.UPSELL_1_S2_6_12,
  },
  [PageIdWoofzS2612.DOWNLOAD_S2_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.DOWNLOAD_S2_6_12,
  },
}
